import strings from 'utils/strings'
import { INTERNAL, SERVICE } from 'constants/featureTypes'
import { mapFrom } from 'utils/functional'

const types = {
  [INTERNAL]: strings.internal,
  [SERVICE]: strings.service,
}

export default mapFrom(types)
